module.exports = __webpack_public_path__ + "static/media/office1.67ea659f.png";